import { __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { EditorContent as EditorContent$1 } from '@tiptap/react';
import { useTheme } from '../../hooks/useTheme.js';
import { useEditorContext } from '../EditorContext/EditorContext.js';

var EditorContent = function (props) {
    var _a = useEditorContext(), editor = _a.editor, disabled = _a.disabled, minHeight = _a.minHeight, maxHeight = _a.maxHeight;
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps(__assign({ disabled: disabled }, props), { themeKey: "editorContent" });
    return (jsx("div", __assign({ css: {
            "--editor-min-height": minHeight,
            "--editor-max-height": maxHeight,
        } }, { children: jsx("div", __assign({}, forwardProps, { children: jsx(EditorContent$1, { editor: editor }) })) })));
};

export { EditorContent };
//# sourceMappingURL=EditorContent.js.map
